<div class="home-page-carousel-tab" *ngIf="carouselSlides?.length > 0">
  <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
    @for (slide of publicSlides; track slide) {
    <div ngxSlickItem class="slide">
      <div class="home-page-carousel-tab__slide" [ngClass]="{'home-page-carousel-tab__slide--withContent': slide?.Title}">
        <img src="{{ slide.Url || '' }}" class="image" alt="" width="100%" />
        <div *ngIf="slide?.Title" class="content">
          <h2>{{ slide.Title }}</h2>
          <p *ngIf="slide?.Subtext">{{ slide.Subtext }}</p>
        </div>
      </div>
    </div>
    }
  </ngx-slick-carousel>

  <div class="home-page-carousel-tab__controller">
    <mat-icon mat-flat-button (click)="slickModal.slickPrev()">chevron_left</mat-icon>
      @for (_ of publicSlides; track _; let index = $index) {
        <div class="mock-dot" (click)="slickModal.slickGoTo(index)"></div>
      }
    <mat-icon mat-flat-button (click)="slickModal.slickNext()">chevron_right</mat-icon>
  </div>
</div>
